import React from "react";
import "./InfoCard.css";

/**
 * Reusable InfoCard component for displaying device information
 * @param {React.ReactNode} icon - The icon component to display
 * @param {string} iconColor - Color for the icon (default: #667eea)
 * @param {string} iconBgColor - Background color for icon container (default: rgba(102, 126, 234, 0.1))
 * @param {string} title - The card title (e.g., "Device ID", "Version")
 * @param {string|number} value - The main value to display
 * @param {string} subtitle - Optional subtitle text
 * @param {string} className - Additional custom classes
 */
function InfoCard({
  icon,
  iconColor = "#667eea",
  iconBgColor,
  title,
  value,
  subtitle,
  className = ""
}) {
  const defaultBgColor = iconBgColor || `${iconColor}1A`; // 1A is ~10% opacity in hex

  return (
    <div className={`info-card ${className}`}>
      <div
        className="info-card-icon"
        style={{ backgroundColor: defaultBgColor }}
      >
        {React.cloneElement(icon, { size: 36, color: iconColor })}
      </div>
      <div className="info-card-content">
        <h3 className="info-card-title">{title}</h3>
        <div className="info-card-value">{value}</div>
        {subtitle && <div className="info-card-subtitle">{subtitle}</div>}
      </div>
    </div>
  );
}

export default InfoCard;
